export default {"src":"/_next/static/media/logo-main.2baf4df3.svg","height":30,"width":30};